module.exports = __webpack_public_path__ + "img/shuangruan.c83ecf45.png";